import { createUseStyles } from 'react-jss'
import { DARK_GRAY_20 } from '@omnilert/components'

export default createUseStyles({
  field: {
    borderBottom: `1px solid ${DARK_GRAY_20}`,
    marginBottom: '0',
    padding: '22px 10px'
  },
  formFieldsContainer: {
    backgroundColor: 'var(--primary__page__background)',
    marginBottom: '25px',
    padding: '0 10px',
    '& $field:not(:nth-child(1))': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between'
    },
    '& $field:last-child': {
      borderBottom: 'none !important'
    }
  },
  helpText: {
    color: 'var(--tips__help__text)',
    fontSize: '12px',
    padding: '0 25px 15px'
  },
  iconContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '24px 0',
    '& svg': { marginTop: '24px' }
  },
  iconTextContainer: {
    '& svg': {
      marginRight: '10px'
    },
    color: 'var(--tips__text)',
    alignItems: 'flex-end',
    display: 'flex'
  },
  label: {
    marginBottom: '5px !important'
  },
  responsive: {
    margin: '0 auto'
  },
  tipForm: {
    overflow: 'auto',
    width: '100%'
  },
  tipsContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    backgroundColor: 'var(--secondary__page__background__color)'
  },
  tipCategoriesField: ({ hasOneCategory }) => ({
    display: hasOneCategory ? 'none' : 'block'
  }),
  tipSelect: {
    border: '1px solid var(--input__border) !important'
  }
})
